module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-tilt-machine-02.e7ee6ef4.jpg";